/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminBenutzerDetailDto } from '../../models/lexplus-admin-benutzer-detail-dto';
import { LexplusCreateAdminBenutzerDto } from '../../models/lexplus-create-admin-benutzer-dto';

export interface AdminBenutzerverwaltungControllerCreateV1$Params {
      body: LexplusCreateAdminBenutzerDto
}

export function adminBenutzerverwaltungControllerCreateV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAdminBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAdminBenutzerDetailDto>;
    })
  );
}

adminBenutzerverwaltungControllerCreateV1.PATH = '/v1/benutzerverwaltung';
